var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheresponse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.73 34.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#ff9500;stroke-miterlimit:10;}.cls-1{stroke-width:1.5px;}.cls-2{stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_13-chat",
    "data-name": " 13-chat"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.42,10.38h-9.3a1,1,0,0,0-1,1v6.2a1,1,0,0,0,1,1h1.55v2.07l2.06-2.07h5.69a1,1,0,0,0,1-1v-6.2A1,1,0,0,0,20.42,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.25,20.19v.52a5.15,5.15,0,0,0,1.51,3.65l-1.51,1.52h5.17A5.17,5.17,0,0,0,23,16.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.15,
    y1: 13.48,
    x2: 19.38,
    y2: 13.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.15,
    y1: 15.54,
    x2: 19.38,
    y2: 15.54
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 17.37,
    cy: 17.37,
    r: 16.37
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheresponse);
export default __webpack_public_path__ + "static/media/The response.158cca3611634a327f3e3a51f36a86e8.svg";
export { ForwardRef as ReactComponent };